import api from "@/services/apiService";

/**
 * Global search must use the same host-aware API client as the rest of the app.
 * A separate axios instance with a baked VUE_APP_API_URL causes cross-origin
 * calls (admin/tenant SPA → apex API) that show up as CORS errors in the browser.
 */
export default {
  async search(params = {}) {
    return api.get("search/global", params);
  },
};
